import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const courses = [
  {
    id: 1,
    title: '法式马卡龙专修课',
    category: '甜点',
    level: '进阶',
    duration: '5天',
    schedule: '周一至周五',
    price: '¥3,800',
    originalPrice: '¥4,500',
    description: '深入学习法式马卡龙的制作工艺，掌握意式蛋白霜制作、配色技巧、夹馅调制等核心技术。',
    highlights: ['意式蛋白霜制作', '外壳调色技巧', '20+款夹馅配方', '商业级出品标准'],
    image: '/images/macaron.jpg',
  },
  {
    id: 2,
    title: '欧式面包综合课',
    category: '面包',
    level: '零基础',
    duration: '7天',
    schedule: '周一至周日',
    price: '¥4,500',
    originalPrice: '¥5,200',
    description: '从基础到进阶，学习法式、意式、德式面包的经典制作工艺，包括天然酵母培养、整形技巧、烘烤工艺。',
    highlights: ['天然酵母培养', '经典整形手法', '多温度发酵', '20+款面包配方'],
    image: '/images/bread.jpg',
  },
  {
    id: 3,
    title: '创意裱花课程',
    category: '蛋糕',
    level: '初学者',
    duration: '4天',
    schedule: '周三至周六',
    price: '¥3,200',
    originalPrice: '¥3,800',
    description: '韩式裱花技术全面学习，包括奶油霜调制、色彩搭配、花朵造型、插件组装等。',
    highlights: ['韩式奶油霜配方', '花朵造型技巧', '色彩渐变处理', '成品组装设计'],
    image: '/images/cake-decor.jpg',
  },
  {
    id: 4,
    title: '精品甜品大师班',
    category: '甜点',
    level: '进阶',
    duration: '6天',
    schedule: '周二至周日',
    price: '¥5,800',
    originalPrice: '¥6,800',
    description: '蒙布朗、提拉米苏、巴斯克芝士蛋糕、法式千层等经典甜品全面解析，提升甜品艺术造诣。',
    highlights: ['经典甜品制作', '盘式甜品设计', '酱汁调味技巧', '成本控制管理'],
    image: '/images/dessert.jpg',
  },
  {
    id: 5,
    title: '翻糖艺术专业课',
    category: '装饰',
    level: '进阶',
    duration: '5天',
    schedule: '周一至周五',
    price: '¥4,200',
    originalPrice: '¥4,800',
    description: '翻糖蛋糕制作系统学习，从翻糖制作、调色、塑形到整体组装，打造精美翻糖作品。',
    highlights: ['翻糖配方制作', '人偶塑形技巧', '婚礼蛋糕设计', '立体雕刻工艺'],
    image: '/images/gallery-5.jpg',
  },
  {
    id: 6,
    title: '咖啡轻食综合课',
    category: '轻食',
    level: '初学者',
    duration: '3天',
    schedule: '周末班',
    price: '¥2,800',
    originalPrice: '¥3,200',
    description: '咖啡制作与轻食搭配课程，学习拉花技术、手冲咖啡及精致轻食制作，拓宽经营边界。',
    highlights: ['意式咖啡制作', '拉花技巧', '手冲咖啡', '轻食搭配'],
    image: '/images/about-bg.jpg',
  },
]

const categories = ['全部', '甜点', '面包', '蛋糕', '装饰', '轻食']

export default function Courses() {
  return (
    <div className="grain-overlay">
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-cream via-cream to-champagne/10">
        <div className="absolute top-10 right-10 w-64 h-64 bg-caramel/10 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-display text-5xl text-chocolate mb-6">专业课程</h1>
            <p className="text-lg text-chocolate/60 max-w-2xl mx-auto">
              精心设计的课程体系，涵盖从入门到精通的各个阶段，由20年经验的资深导师授课
            </p>
          </motion.div>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((cat, index) => (
              <button
                key={cat}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  index === 0
                    ? 'bg-caramel text-white'
                    : 'bg-cream text-chocolate hover:bg-caramel/20'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Course Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course, index) => (
              <motion.div
                key={course.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-cream rounded-3xl overflow-hidden shadow-lg card-hover group"
              >
                {/* Image Area */}
                <div className="relative aspect-[16/10] bg-gradient-to-br from-caramel/20 to-champagne/20 flex items-center justify-center">
                  <img src={course.image} alt={course.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className="px-3 py-1 bg-caramel text-white text-sm rounded-full">
                      {course.category}
                    </span>
                    <span className="px-3 py-1 bg-white/80 text-chocolate text-sm rounded-full">
                      {course.level}
                    </span>
                  </div>
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-champagne text-chocolate text-sm rounded-full font-medium">
                      优惠
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-chocolate/60 mb-3">
                    <span className="flex items-center gap-1">
                      <span>📅</span> {course.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <span>🕐</span> {course.schedule}
                    </span>
                  </div>

                  <h3 className="font-display text-xl text-chocolate mb-2">{course.title}</h3>
                  <p className="text-chocolate/60 text-sm mb-4 line-clamp-2">{course.description}</p>

                  {/* Highlights */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {course.highlights.map((highlight) => (
                      <span
                        key={highlight}
                        className="px-3 py-1 bg-white text-caramel text-xs rounded-full"
                      >
                        {highlight}
                      </span>
                    ))}
                  </div>

                  {/* Price & CTA */}
                  <div className="flex items-center justify-between pt-4 border-t border-caramel/10">
                    <div>
                      <span className="font-display text-3xl text-caramel">{course.price}</span>
                      <span className="text-sm text-chocolate/40 line-through ml-2">
                        {course.originalPrice}
                      </span>
                    </div>
                    <Link
                      to="/contact"
                      className="px-6 py-2 bg-caramel text-white rounded-lg font-medium hover:bg-caramel-dark transition-colors"
                    >
                      立即报名
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-caramel to-caramel-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl text-white mb-4">不确定哪门课程适合您？</h2>
          <p className="text-white/80 mb-8">
            我们的课程顾问将根据您的基础和时间为您推荐最合适的课程
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-4 bg-white text-caramel rounded-lg font-semibold hover:bg-cream transition-colors"
          >
            免费咨询
          </Link>
        </div>
      </section>
    </div>
  )
}